import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CurriculumEnhancementComponent } from './curriculum-enhancement.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


const routes: Routes = [
  {
    path: '',
    component: CurriculumEnhancementComponent,
    data: {
      title: "Curriculum Enhancement",
      breadcrumb: "Curriculum Enhancement"
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [],
  exports: [RouterModule]
})
export class CurriculumEnhancementRoutingModule { }